import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import './TabSelector.css';

// Shared scenario selector used by both demo panels (non-coding and coding):
// a button row on desktop and a dropdown on mobile, so the selector keeps the
// exact same position and look when switching between the two demo tabs.
const TabSelector = ({ tabs, activeTab, onTabChange }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const activeLabel = tabs.find((tab) => tab.id === activeTab)?.label;

  const handleSelect = (tabId) => {
    onTabChange(tabId);
    setDropdownOpen(false);
  };

  return (
    <>
      <div className="tab-selector__buttons">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab-selector__button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => handleSelect(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="tab-selector__dropdown" onClick={() => setDropdownOpen(!dropdownOpen)}>
        <span>{activeLabel}</span>
        <ChevronDown className={`tab-selector__arrow ${dropdownOpen ? 'open' : ''}`} />
        {dropdownOpen && (
          <div className="tab-selector__list">
            {tabs.map((tab) => (
              <div
                key={tab.id}
                className={`tab-selector__item ${activeTab === tab.id ? 'active' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleSelect(tab.id);
                }}
              >
                {tab.label}
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default TabSelector;
